$(function () {
    let station_select = $("#vendor-filters .vf-station select");
    let network_select = $("#vendor-filters .vf-network select");
    let market_select = $("#vendor-filters .vf-market select");

    station_select.select2();
    network_select.select2();
    market_select.select2();
});
